import React from "react";
import { FaSearch } from "react-icons/fa";
import { useMyContext } from "../Context/MyContext";

function SearchBar() {
  const { searchQuery, setSearchQuery } = useMyContext();

  const handleSubmit = (event) => {
    event.preventDefault();
  };

  const handleClearSearch = () => {
    setSearchQuery("");
  };

  return (
    <div className="mt-2 w-full overflow-visible px-3">
      <form
        onSubmit={handleSubmit}
        className="flex h-11 w-full items-center rounded-full border border-[#7b2cbf]/40 bg-white px-3 shadow-sm transition-all duration-200 focus-within:border-[#7b2cbf] focus-within:ring-2 focus-within:ring-[#7b2cbf]/15"
        style={{
          overflow: "visible",
          WebkitOverflowScrolling: "touch",
        }}
      >
        <input
          type="search"
          value={searchQuery || ""}
          onChange={(event) => setSearchQuery(event.target.value)}
          placeholder="Search CHAREX products..."
          aria-label="Search CHAREX products"
          className="min-w-0 flex-grow border-none bg-transparent px-2 text-sm text-gray-700 outline-none placeholder:text-gray-400"
        />

        {searchQuery && (
          <button
            type="button"
            onClick={handleClearSearch}
            aria-label="Clear search"
            className="mr-1 flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full text-sm font-bold text-gray-400 transition-colors hover:bg-[#f7f0ff] hover:text-[#7b2cbf]"
          >
            ✕
          </button>
        )}

        <button
          type="submit"
          aria-label="Search"
          className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-[#7b2cbf] text-white transition-colors duration-200 hover:bg-[#6923a6]"
          style={{ flexBasis: "40px" }}
        >
          <FaSearch className="h-4 w-4" />
        </button>
      </form>
    </div>
  );
}

export default SearchBar;